
    export default 
    {
    "aeAccountDisconnect": {
        "title": "Tu cuenta Dsers ya no está vinculada a AliExpress. Esto ha hecho que los datos de los pedidos y productos desaparezcan temporalmente. Los datos se recuperarán después de que se vincule a una nueva cuenta de AliExpress."
    }
}